<template>
    <div class="modal fade" :id="modalId" data-keyboard="false" data-backdrop="static" v-show="showModalFlag">
        <div class="modal-dialog" :class="dialogClass">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-success">{{ headerTitle }}</h4>
                    <button type="button" class="close" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { watch } from "vue";
import $ from 'jquery';

export default {
    name: "TheDetailFrameModal",

    props: {
        idModal: String,
        dialogClass: String,
        headerTitle: String,
        showModalFlag: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modalId: this.idModal || '_' + Math.random().toString(36).substr(2, 9),
        }
    },

    methods: {
        showModal() {
            this.$emit('update:showModalFlag', true); // Notify parent to sync state
            $('#' + this.modalId).modal('show');
        },
        closeModal() {
            this.$emit('update:showModalFlag', false); // Notify parent to sync state
            $('#' + this.modalId).modal('hide');
        },
    },

    watch: {
        // React to changes in showModalFlag
        showModalFlag(newVal) {
            if (newVal) {
                this.showModal();
            } else {
                this.closeModal();
            }
        },
    },

    mounted() {
        // Ensure modal is hidden when the component is mounted
        $('#' + this.modalId).modal('hide');
    },
};
</script>

<style>
/* Add any necessary styling */
</style>
